/* eslint-disable sort-keys */

/**
 * Copyright (c) ACT, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/** Colors from E4S Web Design System */
// https://www.figma.com/file/4JazmqwcfRVZyRq6vRkf05/E4S-Web---Design-System?type=design&node-id=2946-25441&mode=design&t=5RBrs8ilrgqPDW2x-4

export const grayscale = {
  black: '#222222',
  darkGray: '#424242',
  lightestGray: '#F2F2F2',
  lightGray: '#E2E2E2',
  midGray: '#BDBDBD',
  neutralGray: '#828282',
  white: '#FFFFFF',
};

/** AKA Rebrand Directive */
export const black = {
  10: '#E4E8EA',
  100: '#000000',
  20: '#DADFE2',
  40: '#CAD1D5',
  60: '#666666',
  80: '#002D61',
  white: '#FFFFFF',
};

export const surface = {
  black,
  grayscale,
};

export const sapphire = {
  100: '#255BBA',
  15: '#DEE6F5',
  30: '#BECEEA',
  50: '#92ADDC',
  600: '#2253A9',
  70: '#668CCF',
  700: '#1A4184',
  800: '#143266',
  900: '#10264E',
};

export const navy = {
  100: '#002D61',
  15: '#D9E0E7',
  30: '#B3C0D0',
  50: '#8096B0',
  600: '#002958',
  70: '#4D6C90',
  700: '#002045',
  800: '#001935',
  900: '#001329',
};

export const seafoam = {
  100: '#ADDED1',
  15: '#F3FAF8',
  30: '#E9F5F1',
  50: '#E6F5F1',
  600: '#9DCABE',
  70: '#C6E8DF',
  700: '#7B9E94',
  800: '#5F7A73',
  900: '#495D58',
};

export const neon = {
  100: '#FBE232',
  15: '#FEFBE0',
  30: '#FEF6C2',
  50: '#FDF098',
  600: '#E4CE2E',
  70: '#FCEB70',
  700: '#B2A024',
  800: '#8A7C1C',
  900: '#695F15',
};

export const orange = {
  100: '#EB6645',
  15: '#FCE8E3',
  30: '#F9D1C7',
  50: '#F5B2A2',
  600: '#D65D3F',
  70: '#F1947D',
  700: '#A74831',
  800: '#813826',
  900: '#632B1D',
};

export const fuchsia = {
  100: '#D66BBD',
  15: '#F9E9F5',
  30: '#F3D3EB',
  50: '#EAB5DE',
  600: '#984C86',
  70: '#E297D1',
  700: '#984C86',
  800: '#763B68',
  900: '#5A2D4F',
};

export const mist = {
  100: '#C9D1D6',
  15: '#F7F8F9',
  30: '#EFF1F3',
  50: '#E4E8EA',
  600: '#B7BEC3',
  70: '#D9DFE2',
  700: '#8F9498',
  800: '#6F7376',
  900: '#54585A',
};

export const teal = {
  100: '#00ADA7',
  15: '#D9F3F2',
  30: '#B3E6E5',
  50: '#80D6D3',
  600: '#009D98',
  70: '#4DC6C1',
  700: '#007B77',
  800: '#005F5C',
  900: '#004946',
};

export const utility = {
  blueAlertFill: '#D1E5F0',
  danger: '#B00020',
  dangerAlertFill: '#EEDDE0',
  savedCollegeHeartFill: '#F94868',
  successAlert: '#2E7D32',
  successAlertFill: '#E1E9E2',
  tealT0: '#00ADA7',
  tealT3: '#99DEDC',
};

const colors = {
  fuchsia,
  mist,
  navy,
  neon,
  orange,
  sapphire,
  seafoam,
  surface,
  teal,
  utility,
};
export default colors;
